module.exports = __webpack_public_path__ + "static/media/logo.2723556d.png";